module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-ellipse-yellow-e4f05a5b3df05afa9a9727f202bb4b70.svg";